module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"whos_selling":"Who’s selling?","assign_sales_team":"Assign sales team members responsible for leads coming from this sales page."},"id":{"whos_selling":"Penjual","assign_sales_team":"Tetapkan anggota tim penjualan yang bertanggung jawab atas leads yang berasal dari halaman penjualan ini."}}')
  delete Component.options._Ctor
}
